import { MetricsWidgetProps } from '../../api/Metrics/Types/MetricsDto'
import { useApiClient } from '../../utils/api/ApiClient'
import { MetricsApiClient } from '../../utils/api/metricsApi'
import { useCallbackWithForceRefresh } from '../../utils/api/useCallbackWithForceRefresh'
import { useFetchOne } from '../../utils/api/useFetch'
import { formatLargeNumber, formatNumberWithCommas } from '../../utils/formatNumber'
import { NumericMetric } from './components/NumericMetric'

export const ActiveClientsMetricsWidget = ({
  introducingBrokerIds,
  countryIds,
}: MetricsWidgetProps) => {
  const metricsApiClient = useApiClient(MetricsApiClient)

  const { callback: fetchData } = useCallbackWithForceRefresh(() => {
    return metricsApiClient.getActiveClientsMetrics({ introducingBrokerIds, countryIds })
  }, [introducingBrokerIds, countryIds])

  const { data, isLoading } = useFetchOne(fetchData)

  const shortValue = data ? formatLargeNumber(data.count, 2) : '0'
  const fullValue = data
    ? formatNumberWithCommas(data.count, { minDecimalPlaces: 0, maxDecimalPlaces: 0 })
    : '0'

  return (
    <NumericMetric
      title='Active Clients'
      value={shortValue}
      tooltip={fullValue}
      isLoading={isLoading}
      hasData={!!data}
    />
  )
}
